import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        // Custom brand colors
        brand: {
          50: { value: "#e6f2ff" },
          100: { value: "#b3d9ff" },
          200: { value: "#80bfff" },
          300: { value: "#4da6ff" },
          400: { value: "#1a8cff" },
          500: { value: "#0073e6" },
          600: { value: "#005bb3" },
          700: { value: "#004280" },
          800: { value: "#002a4d" },
          900: { value: "#00121a" },
        },
      },
      fonts: {
        heading: { value: '"Inter", sans-serif' },
        body: { value: '"Inter", sans-serif' },
      },
    },
    semanticTokens: {
      colors: {
        // Light/Dark mode aware colors
        bg: {
          DEFAULT: {
            value: { _light: "#ffffff", _dark: "#0d1117" },
          },
          subtle: {
            value: { _light: "#f6f8fa", _dark: "#161b22" },
          },
          muted: {
            value: { _light: "#eaeef2", _dark: "#21262d" },
          },
        },
        fg: {
          DEFAULT: {
            value: { _light: "#1f2328", _dark: "#e6edf3" },
          },
          muted: {
            value: { _light: "#656d76", _dark: "#8b949e" },
          },
        },
        accent: {
          DEFAULT: {
            value: {
              _light: "{colors.brand.500}",
              _dark: "{colors.brand.400}",
            },
          },
          muted: {
            value: {
              _light: "{colors.brand.100}",
              _dark: "{colors.brand.800}",
            },
          },
        },
      },
    },
  },
  globalCss: {
    "html, body": {
      bg: "bg",
      color: "fg",
      minHeight: "100vh",
    },
  },
});

export const system = createSystem(defaultConfig, config);
